<template>
  <user-box
    :avatar="avatar()"
    :collapse="sidebar.isMini"
    @click-logout="$emit('click-logout')"
    @click-avatar="shellStore.SET_SETTINGS_SHELL(true)"
  />
</template>

<script setup>
import URLS from './urls'
import { AuthStore } from 'frontendcommon-3'
import { useShellStore } from '@/store'

defineProps(['sidebar'])
defineEmits(['click-logout'])
const shellStore = useShellStore()

function avatar () {
  const imageName = AuthStore.getAvatar()
  if (imageName) return `${URLS.STORAGE_IMAGES}avatars/${imageName}`
  return null
}
</script>
